export const disciplinas = {
    "CN": "Ciências da Natureza e suas Tecnologias",
    "CH": "Ciências Humanas e suas Tecnologias",
    "LC": "Linguagens, Códigos e suas Tecnologias",
    "MT": "Matemática e suas Tecnologias",
};
